<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Template</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Template</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'CMSMediaManager' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
                <button
                  class="btn btn-info"
                  @click="openAddFolderModal"
                  v-if="_.isEmpty(path)"
                >
                  New Folder
                </button>
              </div>
            </div>
            <div class="card-body">
              <vue-dropzone
                ref="mediaManagerVueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-complete="dropzoneComplete"
              ></vue-dropzone>
              <ol class="breadcrumb" style="margin: 10px 0">
                <div
                  class="input-group input-group-sm"
                  style="width: 200px; margin-right: 20px"
                >
                  <input
                    type="text"
                    name="query"
                    v-model="value.query"
                    @keyup="search"
                    v-on:keyup.d.delete="resetSearch"
                    class="form-control float-left"
                    placeholder="Search"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-default" @click="search">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <li>
                  <a href="javascript:void(0)"
                    ><i class="fa fa-th-large"></i>
                  </a>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'CMSMediaManager' }"
                    class="file-name"
                  >
                    &nbsp;Home</router-link
                  >
                </li>
                <li v-if="!_.isEmpty(path)">
                  <router-link
                    :to="{ name: 'CMSMediaManager', query: { path: path } }"
                    class="file-name"
                  >
                    &nbsp; >> &nbsp;{{ path }}</router-link
                  >
                </li>
              </ol>
              <media-list :list="list" :path="path" @reload="reload" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <add-folder-modal @reload="reload" />
  </div>
</template>

<script>
import axios from "axios";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import localStorage from "@/services/localStorage";
import AddFolderModal from "./components/AddFolderModal.vue";
import MediaList from "./components/MediaList.vue";

export default {
  name: "CMSMediaManager",
  components: {
    vueDropzone: vue2Dropzone,
    AddFolderModal,
    MediaList,
  },
  metaInfo: {
    title: "CMS Media Manager | Dotlines",
  },
  data: () => ({
    list: {},
    value: {},
    pre: {},
    is_loading: false,
    options: {},
    path: "",
    dropzoneOptions: {
      url: "",
      thumbnailWidth: 150,
      maxFilesize: 3000,
      headers: {},
      addRemoveLinks: false,
      acceptedFiles:
        "image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx,.pages,.odt,.rtf",
    },
    api_url: "",
  }),
  created: function () {
    const token = localStorage.get("token");
    this.dropzoneOptions.url = this.API_BASE_URL + "/cms_media_manager";
    if (!_.isEmpty(this.$route.query.path)) {
      this.dropzoneOptions.url =
        this.API_BASE_URL + "/cms_media_manager?path=" + this.$route.query.path;
    }
    this.dropzoneOptions.headers = { Authorization: "Bearer " + token };
    /*console.log('this.dropzoneOptions.url', this.dropzoneOptions.url);
    console.log('this.$route.query', this.$route.query);*/
  },
  mounted: function () {
    this.initialize();
  },
  methods: {
    initialize() {
      this.api_url = "/cms_media_manager";
      this.is_loading = true;
      this.params = this.$route.params;
      this.reload();
      if (!_.isEmpty(this.$route.query.path)) {
        this.path = this.$route.query.path;
      }
      this.is_loading = false;
    },
    openAddFolderModal: function (id = 0) {
      this.$bvModal.show("add-modal");
    },
    search: function () {
      let query = this.value.query;
      this.list = _.filter(
        this.list,
        function (o) {
          return o.name.match(query);
        }.bind(query)
      );
    },
    resetSearch: function () {
      // this.value.query = '';
      this.reload();
    },
    async reload() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    async dropzoneComplete(response) {
      this.$refs.mediaManagerVueDropzone.removeAllFiles(true);
      //console.log('response::', response.xhr.response);
      if (response.status == "error") {
        Notification.error({
          title: "Upload failed!",
          message: "Unsupported file format",
          type: "error",
        });
      } else {
        Notification.success({
          title: "Upload Completed",
          message: "File uploaded successfully",
          type: "success",
        });
        this.reload();
      }
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = { ...this.filter, ...this.$route.query, ...params };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error", error.response.data);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
